import config from '../../config';

function AdContainer() {
  const footerStyles: React.CSSProperties = {
    position: 'static',
    width: '100%',
    backgroundColor: '#888',
    color: 'white',
    textAlign: 'center',
    padding: '1rem 0 1rem 0',
    fontSize: '14px',
    display: 'none',
  };

  return (
    <div className="adsContainer" style={footerStyles}>
      <p>
        This site is built with
        <a href={config.defaultUrlLandingPage}>&nbsp Build-self &nbsp</a>
        .
      </p>
    </div>
  );
}

export default AdContainer;
